<div class="content-padding">
    <div class="content-wrapper mt-3">
        <div class="content-body">
            <section class="d-flex flex-column justify-content-center align-items-center">
                <form [formGroup]="cardForm" (ngSubmit)="cardSubmit()">
                <div class="content-header mb-2">
                    <h2 class="fw-bolder mb-75">Choose a service</h2>
                </div>
                <!-- select plan options -->
                <div class="row custom-options-checkable gx-3 gy-2">
                    <div class="col-md-6">
                        <input class="custom-option-item-check" formControlName="product" type="radio" name="product" id="basicPlan" value="SIX_MONTH_PACK" />
                        <label class="custom-option-item text-center p-1" for="basicPlan">
                            <span class="custom-option-item-title h3 fw-bolder">6 Month Pack</span>
                            <!-- <span class="d-block m-75">A simple start for everyone</span> -->
                            <span class="plan-price">
                                <sup class="font-medium-1 font-weight-bold text-primary">$ </sup>
                                <span class="pricing-basic-value font-weight-bolder text-primary">{{servicesPrice?.SIX_MONTH_PACK}}</span>
                                <!-- <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/month</sub> -->
                            </span>
                        </label>
                    </div>
    
                    <div class="col-md-6">
                        <input class="custom-option-item-check" formControlName="product" type="radio" name="product" id="standardPlan" value="YEARLY_PACK" />
                        <label class="custom-option-item text-center p-1" for="standardPlan">
                            <span class="custom-option-item-title h3 fw-bolder">Yearly Pack</span>
                            <!-- <span class="d-block m-75">For small to medium businesses</span> -->
                            <span class="plan-price">
                                <sup class="font-medium-1 font-weight-bold text-primary">$ </sup>
                                <span class="pricing-basic-value font-weight-bolder text-primary">{{servicesPrice?.YEARLY_PACK}}</span>
                                <sub class="pricing-duration text-body font-medium-1 font-weight-bold text-decoration-line-through">/$600</sub>
                            </span>
                        </label>
                    </div>
    
                    <!-- <div class="col-md-4">
                        <input class="custom-option-item-check" formControlName="product" type="radio" name="product" id="nftPlan" value="NFT_ONLY" />
                        <label class="custom-option-item text-center p-1" for="nftPlan">
                            <span class="custom-option-item-title h3 fw-bolder">Enterprise Pack</span>
                            <span class="plan-price">
                                <span class="plan-price">
                                    <a href="mailto:hello@alphatrend.ai" class="font-medium-5 font-medium-1 font-weight-bolder">Contact Us</a>
                                </span>
                            </span>
                        </label>
                    </div> -->
                </div>
                <!-- / select plan options -->
                
                <div class="row">
                    <div class="col-12">
                        <div class="content-header py-1">
                            <h2 class="fw-bolder">Referral Code</h2>
                            <span>Enter Referral Code</span>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <div class="input-group input-group-merge">
                            <input id="addCardNumber" [formControl]="referalCode" name="addCard" class="form-control" type="text" />
                        </div>
                        <div *ngIf="codeError" class="invalid-feedback d-block">
                            <div>Invalid Code</div>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="userStatus == 'free' || userStatus == 'canceled'">

                    <div class="content-header my-2 py-1">
                        <h2 class="fw-bolder mb-75">Payment Information</h2>
                        <span>Enter your card Information</span>
                    </div>
        
                    <div class="row gx-2">
                        <div class="col-12 col-md-6 col-lg-3 mb-1">
                            <label class="form-label" for="addCardNumber">Card Number</label>
                            <div class="input-group input-group-merge">
                                <input id="addCardNumber" formControlName="number" name="addCard" class="form-control credit-card-mask" type="text" placeholder="1356 3215 6548 7898" mask="0000 0000 0000 0000 || 0000 000000 00000" aria-describedby="addCard" data-msg="Please enter your credit card number" />
                            </div>
                        </div>
        
                        <div class="col-6 col-md-6 col-lg-3 mb-1">
                            <label class="form-label" for="addCardExpiryDate">Month</label>
                            <input type="text" id="addCardExpiryDate" formControlName="expMonth" class="form-control expiry-date-mask" placeholder="MM" mask='00' />
                        </div>
        
                        <div class="col-6 col-md-6 col-lg-3 mb-1">
                            <label class="form-label" for="addCardExpiryDate">Year</label>
                            <input type="text" id="addCardExpiryDate" formControlName="expYear" class="form-control expiry-date-mask" placeholder="YYYY" mask='0000' />
                        </div>
        
                        <div class="col-6 col-md-6 col-lg-3 mb-1">
                            <label class="form-label" for="addCardCvv">CVV</label>
                            <input type="text" id="addCardCvv" formControlName="cvc" class="form-control cvv-code-mask" maxlength="4" placeholder="****" />
                        </div>
                    </div>

                </ng-container>
    
                <div *ngIf="errorMessage">
                    <ngb-alert class="p-1 w-100" [dismissible]="true" [type]="'danger'">{{ errorMessage }}</ngb-alert>
                </div>
                <div class="d-flex justify-content-end mt-1">
                    <button type="submit" class="btn btn-success btn-submit">
                        <ng-container *ngIf="!isLoading">
                            <span class="align-middle d-sm-inline-block">Submit</span>
                        </ng-container>
                        <ng-container *ngIf="isLoading">
                            <div class="spinner-border spinner-border-sm" role="status"></div>
                        </ng-container>
                    </button>
                </div>
                </form>
            </section>
        </div>
    </div>
</div>